module.exports = __webpack_public_path__ + "75a26a661342891421044313d484bee8.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/CoronaBar.jpg
// module id = 556
// module chunks = 0